import StoreAiCallContractWorkflowCommonLoader from '../libraries/store-ai-call-contract-workflow-common-loader'

export default {

  edit() {
    StoreAiCallContractWorkflowCommonLoader()
  }
}
